<header class="hidden-print">
  <div class="container mb-2 mb-md-5">
    <div class="row mt-3 position-relative">
      <div class="btn-menu-mobile d-block d-lg-none">
        <button class="btn btn-icon mt-3" (click)="showSideMenu()">
          <i-feather class="mobile-menu-icon" name="menu"></i-feather>
        </button>
      </div>
      <div class="col-12 col-lg-3" *ngIf="isLoaded">
        <div class="text-center text-lg-left">
          <a routerLink="/portales">
            <img [ngClass]="getLogoClass()" alt="Logo" [src]="getLogoSrc()" />
          </a>
        </div>
      </div>

      <div class="col d-none d-lg-block main-navigation-container align-self-end w-75">
        <app-desktop-menu [menu]="menu"></app-desktop-menu>
      </div>
      <div class="d-none d-lg-block col-1" dropdown [insideClick]="true">
        <button
          id="button-animated"
          dropdownToggle
          type="button"
          class="dropdown-toggle btn-logout-dropdown small-shadow-box float-right"
          [ngClass]="{ 'btn-logout-dropdown-unit': isUnitPortalStyle }"
          aria-controls="dropdown-animated"
        ></button>
        <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-animated">
          <li class="pt-4 pb-1 pl-4 pr-4 company-title">
            <h5 uni-heading>{{ currentUser?.companiaNombre | titlecase }}</h5>
          </li>
          <li class="pb-1 user-info-header" role="menuitem">
            <h6 uni-heading weight="normal" color="lighten">
              {{ currentUser?.metadata?.nombres || currentUser?.nombreCompleto }}
            </h6>
          </li>
          <li class="pb-1 user-info-header" role="menuitem">
            <h6 uni-heading weight="normal" color="lighten">{{ currentUser?.metadata?.email || currentUser?.email }}</h6>
          </li>
          <li
            class="pb-4 user-info-header"
            role="menuitem"
            *ngIf="currentUser?.metadata?.email !== currentUser?.metadata?.userCode"
          >
            <h6 uni-heading weight="normal" color="lighten">
              {{ currentUser?.metadata?.userCode }}
            </h6>
          </li>

          <li class="user-info-header py-3" role="menuitem">
            <button type="button" class="btn btn-default p-0" [ngClass]="getNavigationMenu()" (click)="resetPassword()">
              Cambiar Contraseña
            </button>
          </li>

          <li class="user-info-header" role="menuitem" *ngIf="currentUser.usuarioPerfil.length > 1">
            <app-select-profile-dropdown [selectedOptionLabel]="getSelectedProfileName()">
              <uni-radio-group [(ngModel)]="selectedProfile" (ngModelChange)="onOptionSelected()">
                <uni-radio-button
                  *ngFor="let profile of currentUser.usuarioPerfil"
                  [value]="profile.perfilId"
                  styleVariant="modern"
                  [checkedValue]="selectedProfile"
                  [name]="profile.perfil.nombre"
                >
                  {{ profile.perfil.nombre }}
                </uni-radio-button>
              </uni-radio-group>
            </app-select-profile-dropdown>
          </li>

          <li *ngIf="!isUnitPortalStyle" class="py-3 user-info-header" role="menuitem">
            <a class="btn btn-default p-0" [ngClass]="getNavigationMenu()" [routerLink]="['/portales/manuales']"
              >Instructivos de Uso</a
            >
          </li>

          <li role="menuitem" class="logout-link">
            <button type="button" class="btn btn-default text-primary" (click)="signOut()">Salir</button>
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="showStatusBar" class="row mt-3">
      <div class="col-md-12">
        <div [ngClass]="getHeaderByCompany()">
          <div class="breadcrumb-desktop">
            <uni-breadcrumb *ngIf="routesData$ | async as routesData">
              <uni-breadcrumb-item *ngFor="let route of routesData" [url]="route.url"> {{ route.title }} </uni-breadcrumb-item>
            </uni-breadcrumb>
          </div>
          <div class="breadcrumb-mobile">
            <uni-breadcrumb>
              <uni-breadcrumb-item url="/portales">Inicio</uni-breadcrumb-item>
            </uni-breadcrumb>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-mobile-menu
    (hideMenu)="sideMenu = false"
    [active]="sideMenu"
    [currentUser]="currentUser"
    [menu]="menu"
    (signOut)="signOut()"
  ></app-mobile-menu>
</header>
